import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import {
  FeedbackParticipantsResponseType,
  useActivityFeedbackParticipants
} from "PFCore/hooks/queries/activity/use_activity_feedback_participants";
import { ActivityParticipant, ParticipatedRole } from "PFTypes/activity_participant";
import { useEffect, useMemo } from "react";

type FeedbackRecipientData = {
  selectedParticipant: ActivityParticipant | undefined;
  selectedRole: ParticipatedRole | undefined;
};

export const useManagerFeedbackParticipants = (
  profileId?: number,
  roleId?: number,
  onSuccess?: (res: FeedbackParticipantsResponseType) => void
): FeedbackRecipientData => {
  const activity = useCurrentActivity();
  const { data, dataUpdatedAt } = useActivityFeedbackParticipants(activity?.id);

  useEffect(() => {
    if (data) {
      onSuccess?.(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdatedAt]);

  const selectedParticipant = useMemo(
    () => data?.entries.find((participant) => participant.id === profileId),
    [data?.entries, profileId]
  );

  const selectedRole = useMemo(
    () => selectedParticipant?.roles.find((role) => role.id === roleId),
    [selectedParticipant?.roles, roleId]
  );

  return { selectedParticipant, selectedRole };
};
